<template>
  <div class="t-trapezoid-tag">
    <div class="trapezoid-tag__box">
      <div class="trapezoid-tag__l"></div>
    </div>
    <div class="trapezoid-tag__c">
      <span>{{ txt }}</span>
    </div>
    <div class="trapezoid-tag__box">
      <div class="trapezoid-tag__r"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TTrapezoidTag',
  props: {
    txt: String
  }
}
</script>

<style lang="less" scoped>
.t-trapezoid-tag {
  color: #fff;
  font-size: 12px;
  position: relative;
  display: flex;
  .trapezoid-tag__box {
    overflow: hidden;
    height: 15px;
  }
  .trapezoid-tag__l {
    margin-right: -4px;
    border-color: rgba(0,0,0,0.5) rgba(0,0,0,0.5) transparent transparent;
    border-style: solid;
    border-top-width: 10px;
    border-right-width: 5px;
    border-bottom-width: 24px;
    border-left-width: 2px;
  }
  .trapezoid-tag__c {
    background-color: rgba(0,0,0,0.5);
    padding: 4px 8px;
    height: 20px;
    line-height: 12px;
    border-radius: 0 0 6px 6px;
  }
  .trapezoid-tag__r {
    margin-left: -4px;
    border-color: rgba(0,0,0,0.5) transparent transparent rgba(0,0,0,0.5);
    border-style: solid;
    border-top-width: 10px;
    border-right-width: 2px;
    border-bottom-width: 24px;
    border-left-width: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TTrapezoidTag.vue